module.exports = __webpack_public_path__ + "public/img/jqpic_03.a5aada97.png";